import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import Spinner from "../../../base/features/micro/Spinner";
import Image from "../../../base/features/micro/Image";
import { intro } from "./services";
import Carousel from "react-multi-carousel";

class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      introItems: null,
      responsive: {
        superLargeDesktop: {
          breakpoint: { max: 4000, min: 3000 },
          items: 1,
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        },
      },
      buttonTitle: "",
    };
  }
  componentDidMount() {
    this.getIntro();
  }
  getIntro() {
    intro("new-shop").then((items) => {
      items &&
        this.setState({
          introItems: items.items,
          buttonTitle: items.button_title,
        });
    });
  }
  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
          isOpen={this.props.introModal}
          toggle={() => this.props.changeModal(!this.props.introModal)}
        >
          <ModalBody className="row mx-0 px-4 py-3">
            {this.state.introItems ? (
              <div className="col-12 px-0 py-2" dir="ltr">
                <Carousel
                  className="mb-4"
                  autoPlay={false}
                  responsive={this.state.responsive}
                  showDots={true}
                  infinite={true}
                  draggable={true}
                  swipeable={true}
                  keyBoardControl={true}
                  arrows={false}
                  sliderClass="h-100 mb-4"
                  containerClass="carousel-container"
                  dotListClass="custom-dot-list-style"
                >
                  {this.state.introItems.map((item, i) => (
                    <div className="row mx-0">
                      <div className="col-12 px-0 text-center">
                        <Image
                          imageHeight={"180"}
                          // imageWidth={"180"}
                          extraClassName={"p-0 img-contain"}
                          imgClassName={"mb-4"}
                          imageUri={item.media.file}
                        />
                        <p className="fw-bold fs-4">{item.title}</p>
                        <p className="fw-bold small" dir="rtl">
                          {item.des}
                        </p>
                      </div>
                    </div>
                  ))}
                </Carousel>
                <button
                  onClick={() => this.props.changeModal(false)}
                  className="btn w-100 py-2-3 small fw-bold text-white bg-color-main rounded28"
                >
                  {this.state.buttonTitle}
                </button>
              </div>
            ) : (
              <Spinner />
            )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Intro;
